import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormCheckboxStyles = makeStyles()((theme: Theme) => ({
	label: {
		marginLeft: theme.spacing(-0.75),
		"& > :last-of-type": {
			fontWeight: theme.typography.fontWeightMedium,
			marginLeft: theme.spacing(0.5),
		},
		"&[aria-disabled]": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
	},
	checkbox: {
		padding: theme.spacing(0.5),
		"& svg": {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
		},
	},
}));
